<template>
    <ui-modal :load="loading" name="docu-sign-integration" icon="-">
        <template #title>
            <div class="modal-title">
                <em class="fal fa-cog" />

                <span class="title">Integração com DocuSign</span>
            </div>
        </template>

        <template>
            <div class="content-body">
                <div v-if="!status" class="connect">
                    <div class="image-docu-sign">
                        <img :src="docuSignImg" alt="docu-sign" />
                    </div>

                    <span class="text-docu-sign">Para se conectar à sua conta do DocuSign clique no botão abaixo.</span>

                    <ui-button design="mw-250 yellow" @click="connect">Conectar minha conta</ui-button>
                </div>

                <div v-else class="integration-status">
                    <label>Status:</label>

                    <div class="integration-message">
                        <div class="oval" />

                        <span>
                            DocuSign está conectado
                        </span>
                    </div>

                    <div class="remove-integration">
                        <span @click="remove">Remover Integração</span>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <span class="cancel" @click="close">
                Cancelar
            </span>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'

    import { mapActions, mapGetters } from 'vuex'

    import { facilita } from '@/global'

	export default {
		name: 'click-sign-integration',

		components: {
			uiModal,
			uiButton
		},

        data() {
            return {
                status: false,
                loading: false
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                integration: 'getIntegration'
            }),
            docuSignImg() {
                return require('@/assets/imgs/docu-sign-simbolo.png')
            },
        },

        created() {
            this.$root.$on('modal-open-docu-sign-integration', () => {
                this.check()
            })
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'authenticate',
                'desintegrate'
            ]),
            /**
             * Envia os dados necessários para a integração para o backend, de modo
             * que as medidas de segurança sejam tomadas e as informações sejam salvas
             */
            connect() {
                this.loading = true
                let url = `${facilita.oauthUrl.replace('#', 'docusign')}?instance=${facilita.instance}&environment=${facilita.environment}&integration_id=${this.integration?.id}`
                if (facilita.environment === 'development') url += `&api_url=${facilita.apiUrl}`
                window.open(url, '_blank').focus()
            },
            /**
             * Remove as configurações da integração atual
             */
            remove() {
                this.loading = true
                this.desintegrate()
                    .then(() => {
                        this.status = false
                        this.close()
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            /**
             * Verifica se a integração está conectada corretamente
             */
            check() {
                this.loading = true
                this.authenticate()
                    .then(response => {
                        this.status = response.data.data
                    })
                    .catch(error => {
                        if (error?.data?.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                        this.status = false
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            /**
             * Fecha o modal de autenticação
             */
            close() {
                this.$root.$emit('modal-close-docu-sign-integration')
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>